var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('SingleSQ',{attrs:{"questionData":_vm.questionData,"btnWidth":500,"oneOption":false,"pendingOption":true,"sq_numberData":'sq_fortyNineData',"sqOptions":[],"secondRadioB":false},on:{"goBackInScoringHistory":_vm.goBackInScoringHistory}})}
var staticRenderFns = []

export { render, staticRenderFns }